export default {
  title: "Подробно об RC CITY",

  balance: {
    title: "Баланс",
    info: {
      title: "Информация о балансе",
      paragraphs: [
        "Баланс отражает информацию о ваших средствах, которые будут выплачены вам в период взаиморасчетов.",
        "Также на странице баланс представлена полная его детализация, которая помогает лучше контролировать свои финансы и понимать текущее состояние своих средств.",
      ],
    },
    settings: {
      title: "Настройка вывода средств",
      paragraphs: [
        "Чтобы вывести средства, нужно выбрать способ выплаты в настройках. Выплата будет осуществлена согласно договору п. 4.6. Если не выбрать ни один из вариантов в кабинете RC CITY, в указанный период выплата средств для данного юрлица производиться не будет.",
        "Чтобы установить сумму, которую вы хотите вывести, необходимо:",
      ],
      list: [
        {
          text: "Перейти в раздел «Баланс», нажав на кнопку «Баланс» в правом верхнем углу.",
        },
        {
          text: "Нажать «Настройки» в карточке баланса.",
        },
        {
          text: "Выбрать предпочтительный способ выплаты средств:",
          list: [
            "По сумме «Зарезервировано к выводу»Средства будут зарезервированы до момента выплаты, их нельзя будет использовать на покупки тарифов и услуг, т.к фактический баланс будет уменьшен на установленное значение. Способ недоступен, когда значение суммы «Доступно к выводу» меньше 300 RC. Сумму вы устанавливаете самостоятельно.",
            "По сумме «Доступно к выводу»Выплата средств будет сумме, равной значению баланса “Доступно к выводу” на момент проведения взаиморасчетов при условии, что она будет не менее 300 RC",
          ],
        },
        {
          text: "Нажмите на «Применить и закрыть».",
        },
      ],
    },
  },

  analytic: {
    title: "Аналитика",
    entities: {
      title: "Юрлица",
      paragraphs: [
        "В разделе <b>«Аналитика»</b> представлена аналитика по всем вашим заведениям и клиентам, которые используют в RC PAY. Информация представлена на пяти вкладках с акцентом на разные данные.",
        "На вкладке <b>«Юрлица»</b> можно посмотреть общие данные по клиентам, в том числе новым, а также узнать средний чек, количество покупок и общую сумму продаж. Кроме того, предусмотрена возможность получить подробную информацию по каждой зарегистрированной организации и выбрать интересующий Вас период, что позволит узнать количество продаж за день, неделю, месяц, год.",
      ],
    },
    points: {
      title: "Торговые точки",
      p1: "На вкладке <b>«Торговые точки»</b> расположена расширенная аналитика предыдущего подраздела:",
      list: [
        "данные по клиентам;",
        "продажи;",
        "сумма продаж за необходимый период;",
        "данные по каждой организации;",
        "информация об активности сотрудников;",
        "сумма продаж по каждому сотруднику;",
        "очки кассирам.",
      ],
      p2: "Выбрав <b>«Все торговые точки»</b>, можно просмотреть общую информацию по всем имеющимся торговым точкам.",
    },
    employees: {
      title: "Сотрудники",
      p1: "На вкладке <b>«Сотрудники»</b> Вы можете отслеживать активность Ваших сотрудников и оценивать их продуктивность за тот или иной период по следующим критериям:",
      list: [
        "имя сотрудника, проводившего транзакцию;",
        "торговую точку;",
        "количество продаж;",
        "сумму продаж;",
        "очки кассира;",
        "количество списанных баллов;",
        "количество начисленных баллов.",
      ],
      p2: "Выбрав <b>«Все торговые точки»</b>, можно просмотреть общую информацию по всем имеющимся торговым точкам.",
    },
    rfm: {
      title: "RFM-анализ",
      paragraphs: [
        "На вкладке <b>«RFM-анализ»</b> представлен анализ сегментации клиентов по частоте и сумме покупок. Он помогает выявлять тех клиентов, которые больше всего покупают у вас.",
        "Для получения информации выберите <b>«Юрлицо»</b> из всплывающего меню и период в <b>«Календаре»</b>. По итогу отобразится таблица с результатами анализа групп, которые вы сформировали в <b>«Начислении баллов»</b>.",
      ],
    },
    portrait: {
      title: "Портрет клиента",
      paragraph:
        "На вкладке <b>«Портрет клиента»</b> Вы можете детально просмотреть информацию обо всех клиентах выбранной организации, выявить постоянных клиентов. На графике возраста можно ознакомиться с дополнительными данными по возрастным категориям:",
      list: [
        "количеством клиентов данной возрастной категории;",
        "их средним чеком;",
        "количеством покупок;",
        "суммой покупок.",
      ],
    },
  },

  loyalty: {
    title: "Программа лояльности",

    accrualPoints: {
      title: "Начисление баллов",
      p1: "В разделе <b>«Начисление баллов»</b> Вы можете настроить размер начисляемых баллов. Минимальный процент начисления – 4%, а максимальный – 25%. Чтобы усилить лояльность клиентов, группируйте их в зависимости от суммы покупок и назначайте каждой группе свой процент вознаграждения.",
      p2: "Для создания группы клиентов выполните следующие действия:",
      list: [
        {
          text: "Выберите торговые точки, для которых Вы хотите создать группу клиентов. Например:",
          list: [
            "Новый клиент с покупками на сумму до 10 000 рублей – вознаграждение составит 5%.",
            "Постоянный клиент с покупками от 10 000 рублей – вознаграждение составит 10%.",
            "Любимый клиент с покупками от 50 000 рублей – вознаграждение составит 20%.",
          ],
        },
        { text: "Нажмите кнопку «Создать группу»." },
      ],
      p3: "На этой странице также есть возможность установить <b>«Текущую задержку торговой точки»</b> – это количество дней, спустя которое клиенту будет начислено вознаграждение за покупку. Значение может быть от 0 до 14 дней. Нажмите кнопку <b>«Изменить задержку»</b>, чтобы указать желаемый срок, а затем – <b>«Сохранить»</b>. Обратите внимание: функция будет работать корректно только при положительном балансе в RC CITY.",
    },

    promo: {
      title: "Акции",
      p1: "В подразделе <b>«Акции»</b> Вы можете создавать и отслеживать акции для своих заведений сразу или по отдельности. Информация представлена в виде таблицы со столбцами следующего содержания: название акции, торговая точка, где она проходит, процент начисления баллов (не суммируется с процентами начисления баллов из предыдущего раздела), процент скидки. Также напротив каждой акции предусмотрена возможность скрыть из <b>RC KASSA</b> у сотрудника редактировать и удалить.",
      p2: "Для того, чтобы создать акцию в всплывшем окне укажите:",
      list: [
        "торговую точку,",
        "название акции,",
        "процент начисления баллов,",
        "процент скидки.",
      ],
      p3: "После успешного создания акции Вы можете зайти, как сотрудник в <b>RC KASSA</b>, и при нажатии кнопки <b>«Акции»</b>, отобразиться созданная в кабинете акция.",
    },

    operations: {
      title: "История операций",
      paragraphs: [
        "На вкладке <b>«Все операции»</b> в подразделе <b>«История операций»</b> будет отображена таблица со всеми пополнениями и списаниями средств с баланса в RC CITY. Чтобы получить более подробную информацию, Вы можете указать нужный вам период в календаре.",
        "Также на этой странице Вы можете скачать историю операций за определенный период или за все время использования кабинета. Чтобы сделать это, нажмите кнопку <b>«Скачать»</b>, выберите формат скачивания и, по желанию, установите флажок <b>«Отправить копию на электронную почту»</b>. В этом случае файл будет отправлен на Вашу электронную почту, указанную при регистрации в RC CITY. После этого снова нажмите кнопку «Скачать».",
        "На вкладке <b>RC Processing</b> Вы можете увидеть информацию по всем проведенным операциям на кассовых аппаратах.",
      ],
    },
  },

  clients: {
    title: "Клиенты",
    clients: {
      title: "Список клиентов",
      paragraphs: [
        "В разделе «Список клиентов» доступна информация о Ваших покупателях. Чтобы просмотреть данные, выберите организацию из выпадающего списка или отметьте флажком пункт «Все организации».",
        "На вкладке <b>«Все клиенты»</b> вы увидите информацию обо всех клиентах Вашего заведения. Вкладка <b>«Внутренние клиенты»</b> покажет данные о клиентах, оцифрованных в Вашем заведении. На вкладке <b>«Внешние клиенты»</b> представлена информация о клиентах, которые посещали Ваше заведение и сделали в нем хотя бы одну покупку.",
        "Внизу страницы Вы также найдете кнопку <b>«Пригласить»</b>, нажав на которую можно скопировать ссылку или скачать QR-код для регистрации клиента.",
      ],
    },
    reviews: {
      title: "Отзывы",
      p1: "В подразделе «Отзывы» отображаются отзывы всех клиентов, которые посещали Ваше заведение и оставили отзыв на сайте rcpay.ru или в приложении RC PAY.",
      p2: "Для удобной работы с отзывами доступно несколько фильтров:",
      list: [
        {
          text: "При нажатии кнопки <b>«Выберите торговую точку»</b> отобразятся все отзывы, оставленные клиентом о данной точке. При выборе пункта <b>«Все торговые точки»</b> Вы сможете увидеть отзывы на все торговые точки.",
        },
        {
          text: "Предусмотрена возможность посмотреть отзывы за определенный период или дату. Для этого откройте календарь, выберете из списка нужный период или задайте его в календаре.",
        },
        {
          text: "Отфильтровать отзывы можно по 3 характеристикам:",
          list: [
            "по новизне;",
            "только положительные;",
            "только отрицательные.",
          ],
        },
      ],
      p3: "Также Вы можете выбрать конкретные отзывы, которые будут отображены на сайте rcpay.ru и в приложении RC PAY. Для этого нажмите на знак просмотра у тех отзывов, которые хотите, чтобы отображались на сайте и в приложении. Обратите внимание, что скрытые отзывы не будут влиять на оценку заведения, которая будет отображаться на сайте.",
    },
    push: {
      title: "Push-уведомления Wallet",
      p1: "В подразделе <b>«Push-уведомления Wallet»</b> можно настроить рассылку для Ваших клиентов, чтобы они всегда были в курсе Ваших акций и мероприятий.",
      list: [
        "Для этого нажмите плюс напротив «Создать Push-рассылку» и заполните соответствующие поля;",
        "Выберите Торговую точку, на клиентов которой планируете делать рассылку;",
        "Укажите текст заголовка (например: «праздничные скидки всем»);",
        "Введите текст сообщения push-уведомление в течение 15 минут. Обратите внимание на то, что после создания уведомления изменить его будет невозможно. Все разосланные оповещения отображаются в виде таблицы на этой же странице. По каждому можно нажать «Подробнее» и посмотреть Точку продаж, на которую сделали рассылку, дату отправки и текст.",
      ],
      p2: "Ваши клиенты получат push-уведомление в течение 15 минут. Обратите внимание на то, что после создания уведомления изменить его будет невозможно. Все разосланные оповещения отображаются в виде таблицы на этой же странице. По каждому можно нажать «Подробнее» и посмотреть Точку продаж, на которую сделали рассылку, дату отправки и текст.",
    },
  },

  cards: {
    title: "Карты лояльности",
    spread: {
      title: "Распространение карт RC",
      p: "Карта Wallet — это электронный эквивалент карт магазинов и заведений. В подразделе <b>«Распространение карт RC»</b> можно получить QR-код для использования его в оцифровке клиентов, а также ссылку для скачивания карты, которую можно разместить в социальных сетях, на сайте и любых других источниках, что позволит оцифровывать клиентов в любой точке мира.",
    },
    design: {
      title: "Дизайн карты Wallet",
      p1: "В разделе <b>«Дизайн карты Wallet»</b> предусмотрена возможность создания уникального дизайн ваших карт. Для этого необходимо:",
      list: [
        "Выбрать вариант из выпадающего списка в разделе «Выбрать организацию», для которого Вы хотите создать карты Wallet.",
        "Выбрать фон: перетащите или загрузите файл с изображением в окно «Вставьте картинку для фона вашей Wallet-карты». Обратите внимание, что вес файла не должен превышать 2 МБ, соотношение сторон 16:9.",
        "Выбрать логотип. Перетащите или загрузите файл с изображением в окно Вставьте логотип вашей Wallet-карты. Обратите внимание, что вес файла не должен превышать 2 МБ, соотношение сторон 1:1.",
        "Выберите цвет QR-кода, заголовка и номера карты.",
      ],
      p2: "Чтобы сохранить настройки, нажмите «Изменить дизайн», а для сброса параметров — <b>«Вернуть стандартный дизайн»",
    },
  },

  employee: {
    title: "Мои сотрудники",
    manager: {
      title: "Менеджеры",
      p1: "В разделе <b>«Менеджеры»</b> отображены все менеджеры, которых зарегистрировал владелец ТСП:",
      list: ["Ф.И.О. сотрудника;", "должность;", "номер телефона;"],
      p2: "Также можно добавить, изменить, заблокировать и удалить менеджера. Для того, чтобы добавить менеджера нужно нажать плюс, указать фамилию, имя, отчество, должность, номер телефона и настроить доступ к страницам личного кабинета. Логин и пароль для входа будут сформированы программой автоматически. Помните, что пароль, после добавления менеджера, показывается единожды. Рекомендуем его сохранить в удобном для Вас месте, так как он не будет отображен в программе.",
      p3: "Обратите внимание, что менеджер не имеет доступа к проведению транзакций в приложении RC KASSA.",
    },
    cashier: {
      title: "Кассиры",
      paragraphs: [
        "В разделе «Кассиры» представлены данные по всем созданным сотрудникам. Для создания сотрудника необходимо нажать плюс и ввести фамилию, имя, а также выбрать торговую точку сотрудника. В таблице вы найдете логин, пароль, которые необходимы для входа в RC.Kassa, и статус сотрудника.",
        "Кроме того, в этой вкладке можно посмотреть информацию по набранным баллам, заблокировать, либо удалить сотрудника.",
      ],
    },
  },

  fabrics: {
    title: "Мои предприятия",
    entities: {
      title: "Юрлица",
      p1: "В подразделе <b>«Юрлица»</b> Вы можете добавить имеющуюся у Вас организацию, чтобы впоследствии на ее заведения распространялась программа лояльности. Для этого нажмите знак плюса напротив «Юрлица» и заполните все имеющиеся поля:",
      list1: [
        "ИНН организации;",
        "юридическое наименование;",
        "юридический адрес;",
        "банк, обслуживающий организацию;",
        "БИК;",
        "корреспондентский счет;",
        "расчетный счет;",
        "Ф.И.О. руководителя.",
      ],
      p2: "Обратите внимание особое внимание на корреспондентский и расчетный счета. В них должно быть одинаковое количество цифр и отсутствовать лишние знаки (пробелы и точки). Также при выборе типа организации «Халяль», необходимо загрузить подтверждающий документ в формате pdf, jpeg или png.",
      p3: "Кроме того, возможность добавить вторую и последующие организации присутствует только на платных тарифах. Если у Вас несколько организаций, то Вы можете выбрать, какая из них станет основной и будет действовать даже в случае понижения тарифа. После создании организации Вы сможете отслеживать статус проверки внесенной вами информации со стороны модерации:",
      list2: [
        "«Подтверждено», если все данные заполнены верно и проверка пройдена успешно;",
        "«Отклонено», если информация заполнена неверно или требует уточнения. Пожалуйста, обращайте внимание на комментарии модератора, они подскажут Вам, какую информацию нужно скорректировать;",
        "«На модерации», если организация ожидает проверки или уже проверяется модератором.",
      ],
      p4: "Если модерация будет отклонена, то в поле «Ответ модерации» появится поясняющее причину сообщение. Внимательно изучите его и выполните рекомендации модератора.",
      p5: "Также Вы всегда можете посмотреть информацию о выбранной организации, нажав на кнопку «Подробнее» напротив наименования:",
      list3: [
        "наименование организации;",
        "ИНН;",
        "юридический адрес;",
        "БИК банка;",
        "расчетный счет;",
        "корреспондентский счет;",
        "сумма депозита.",
      ],
    },
    points: {
      title: "Торговые точки",
      paragraphs: [
        "В разделе <b>«Торговые точки»</b> вы найдете список всех зарегистрированных точек, историю чеков. Также здесь есть возможность при необходимости удалить точку.",
        "Для добавления новой торговой точки нажмите кнопку «Создать». Затем заполните все обязательные поля. Для вашего удобства рядом с полями есть подсказки. Постарайтесь максимально подробно и точно описать деятельность вашего заведения и подчеркнуть его уникальность с помощью описания и фотографий.",
        "ажно указать юрлицо, с которым будут производиться взаиморасчеты. Для этого выберите соответствующее юридическое лицо из выпадающего списка. Заполненная информация будет отправлена на модерацию. Вы сможете отслеживать статус проверки после того, как данные торговой точки будут отправлены на модерацию:",
      ],
      list: [
        "«Подтверждено», если все данные заполнены корректно и проверка пройдена успешно. В этом случае Ваша точка будет размещена на сайте rcpay.ru и в приложении RC PAY.",
        "«Отклонено», если недостаточно информации или требуются уточнения. Вы увидите пояснительное сообщение от модератора с рекомендациями по исправлению.",
        "«На модерации», если точка ожидает проверки или уже проверяется модератором.",
      ],
      p: "Чтобы просмотреть историю чеков, нажмите на иконку чека в карточке соответствующей торговой точки. Вы можете отфильтровать, отсортировать таблицу или просмотреть конкретную транзакцию более детально.",
    },
    documents: {
      title: "Документы",
      p: "В разделе «Документы» на вкладках «Документы» и «Маркетинговые материалы» вы сможете ознакомиться с инструкциями и материалами, относящимся к продукции Русского цифрового бизнеса.",
    },
    tariffs: {
      title: "Тарифы",
      p: "В разделе <b>«Тарифы»</b> показаны все имеющиеся тарифы. Чтобы приобрести тариф, выберите интересующее Вас предложение и нажмите «Купить тариф», выберите «Юрлицо» и нажмите кнопку «Оплатить». Для оплаты тарифа вы должны пополнить баланс, для этого сформируйте счет в разделе «Баланс» на сумму стоимости тарифа и произведите оплату с реквизитов, принадлежащих выбранной организации.",
    },
  },

  paymentDecision: {
    title: "Платежное решение",
    paymentMethod: {
      title: "Способы оплаты",
      p1: "Перед подключением платежного решения ознакомьтесь с инструкцией, чтобы узнать необходимые условия для работы. Также рекомендуем проверить, не попадает ли ваше заведение под ограничения, для которых подключение не осуществляется.<br /><br /> В подразделе «Способы оплаты» выберите торговую точку, для которой хотите подключить платежное решение, нажав на выпадающий список.<br /> После выбора торговой точки для подключения вы можете создать заявку.<br /><br /> Проверьте данные перед отправкой заявки:",
      list: [
        "Контактные данные: адрес и номер телефона. Номер телефона необходим для отображения в кассовых чеках и связи с вами.",
        "Юридическое лицо: убедитесь, что вся информация верна.",
        "Банковские реквизиты: проверьте корректность внесенных данных.",
      ],
      p2: "Если вы заметили ошибку в реквизитах, обратитесь в поддержку для изменения данных через форму обратной связи в правом нижнем углу.<br /><br /> После внесения всех данных поставьте галочки напротив пунктов: «Даю свое согласие на обработку персональных данных в соответствии с Политикой конфиденциальности» и «Принимаю условия Лицензионного договора и Политику обработки персональных данных». Затем нажмите «Отправить заявку».<br /><br /> После отправки заявки с вами свяжется менеджер Русского цифрового бизнеса и сообщит о дальнейших действиях по подключению.<br /><br /> Также в подразделе «Способы оплаты» можно отслеживать актуальные статусы подключения платежного решения на вкладке «История заявок».<br /><br /> Чтобы начать принимать оплату заказов от клиентов, необходимо создать торговую точку, добавить товары, включить прием заказов для торговых точек, где будут доступны товары через RC PAY",
    },
  },

  services: {
    title: "Сервисы",
    eMenu: {
      title: "Онлайн-каталог",
      p: "На странице <b>«Онлайн-каталог»</b> Вы можете добавить свои товары или услуги, чтобы клиенты могли ознакомиться с ассортиментом Вашего заведения или магазина на сайте rcpay.ru или в приложении RC PAY. Также внизу страницы Вы можете сформировать и скачать QR-код, который позволит перейти к меню Вашей торговой точки в несколько кликов.",
    },
  },

  contacts: {
    title: "Контакты",
    p: "По всем интересующим вопросам обращайтесь по телефону <b>8 (800) 500-57-62</b> или по электронной почте hello&#64;rc.city. Либо напишите свой вопрос в форму обратной связи, которая расположена в правом нижнем углу, и мы свяжемся с Вами удобным для Вас способом.",
  },
};
